"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealerSearchServiceV3Impl = void 0;
const INSTANCE_ID_SEPARATOR = '@';
class DealerSearchServiceV3Impl {
    constructor(dealerContextService) {
        this.dealerContextService = dealerContextService;
        this.filters = new Map();
        this.listeners = new Map();
        this.selectedDealerData = new Map();
        this.error = new Map();
    }
    parseConsumerId(consumerId) {
        return consumerId === null || consumerId === void 0 ? void 0 : consumerId.split(INSTANCE_ID_SEPARATOR)[0];
    }
    getFilter(consumerId) {
        consumerId = this.parseConsumerId(consumerId);
        return this.filters.get(consumerId);
    }
    getSelectedDealer(consumerId) {
        var _a;
        consumerId = this.parseConsumerId(consumerId);
        const selectedDealer = this.selectedDealerData.get(consumerId);
        const fallbackDealerId = (_a = this.dealerContextService) === null || _a === void 0 ? void 0 : _a.getSelectedDealer();
        if (selectedDealer) {
            return selectedDealer;
        }
        else if (fallbackDealerId) {
            return { id: fallbackDealerId, name: '', address: {}, contact: {} };
        }
        return undefined;
    }
    getListeners(consumerId) {
        var _a;
        consumerId = this.parseConsumerId(consumerId);
        return (_a = this.listeners.get(consumerId)) !== null && _a !== void 0 ? _a : new Set();
    }
    registerOnSelectedDealerChange(consumerId, callback) {
        var _a;
        consumerId = this.parseConsumerId(consumerId);
        this.listeners.set(consumerId, this.getListeners(consumerId).add(callback));
        /**
         * If there is change to fallback dealer and no dealer was selected in dealer search service,
         * we should trigger callback as well to react to fallback change.
         */
        const unSubscribeDealerContextService = (_a = this.dealerContextService) === null || _a === void 0 ? void 0 : _a.subscribe((selectedDealer) => {
            if (!this.selectedDealerData.get(consumerId) && selectedDealer) {
                callback({ id: selectedDealer, name: '', address: {}, contact: {} });
            }
        });
        const unsubscribe = () => {
            this.getListeners(consumerId).delete(callback);
            if (unSubscribeDealerContextService)
                unSubscribeDealerContextService();
        };
        return unsubscribe;
    }
    setFilter(consumerId, filter) {
        consumerId = this.parseConsumerId(consumerId);
        this.filters.set(consumerId, filter);
    }
    setSelectedDealer(consumerId, data) {
        consumerId = this.parseConsumerId(consumerId);
        if (this.getSelectedDealer(consumerId) !== data) {
            this.selectedDealerData.set(consumerId, data);
            this.getListeners(consumerId).forEach((listener) => listener(data));
        }
    }
    setError(consumerId, errorName) {
        consumerId = this.parseConsumerId(consumerId);
        if (this.getError(consumerId) !== errorName) {
            this.error.set(consumerId, errorName);
        }
    }
    getError(consumerId) {
        return this.error.get(consumerId);
    }
}
exports.DealerSearchServiceV3Impl = DealerSearchServiceV3Impl;
//# sourceMappingURL=index.js.map